import { getRootVar } from '@immosky/shared';
import { colorOrange } from '@immosky/styles';
import {
  GeometryType,
  MapShapeRenderer,
  Region,
  RegionID,
} from '@immosky/types';

export class MapPolygonRenderer implements MapShapeRenderer {
  private activePolygons = new Map<RegionID, google.maps.Polygon[]>();
  private regions: Region[] = [];

  constructor(private map: google.maps.Map) {}

  update(regions: Region[]): void {
    this.regions = regions;
    this.createAllPolygons();
  }

  clear() {
    for (const [key, polygons] of this.activePolygons) {
      for (const polygon of polygons) {
        polygon.setMap(null);
      }
    }
    this.activePolygons.clear();
  }

  getBounds(): google.maps.LatLng[] {
    const bounds: google.maps.LatLng[] = [];

    for (const [key, polygons] of this.activePolygons) {
      for (const polygon of polygons) {
        const coordinates = polygon.getPath().getArray();
        for (const coordinate of coordinates) {
          bounds.push(coordinate);
        }
      }
    }

    return bounds;
  }

  private createAllPolygons() {
    for (const region of this.regions) {
      this.createPolygonsForRegion(region);
    }
  }

  private createPolygonsForRegion(region: Region) {
    if (region.geometry.type === GeometryType.POLYGON) {
      if (this.activePolygons.has(region.id)) {
        return;
      }

      const shapes = region.geometry.coordinates;
      const polygons: google.maps.Polygon[] = [];

      for (const shape of shapes) {
        const polygon = new google.maps.Polygon({
          paths: shape,
          strokeColor: getRootVar('--primary-color', colorOrange),
          strokeWeight: 2,
          strokeOpacity: 0.4,
          fillColor: getRootVar('--primary-color', colorOrange),
          fillOpacity: 0.2,
          map: this.map,
          clickable: false,
        });

        polygons.push(polygon);
      }

      this.activePolygons.set(region.id, polygons);
    }
  }
}
